import React from 'react';
import {Flex} from "antd";
import {LauncherLayout} from "../layout/LauncherLayout";
import {RpgLodgeStats} from "./RpgLodgeStats";
import {ActiveEvents} from "./ActiveEvents";

export const HomePage = () => {
    return (
        <LauncherLayout>
            <Flex vertical={true} justify={"start"} align={"center"}>
                <RpgLodgeStats />
                <ActiveEvents />
            </Flex>
        </LauncherLayout>
    )
};